import { iconChevronSmall180 } from '@tesla/design-system-icons';
import cx from 'classnames';
import React, { useState } from 'react';
import { Icon } from '../icon/index.js';
import { NavItem } from '../nav-item/index.js';
import { SideNavItemGroup } from './side-nav-item-group.js';
export const SideNavItem = ({ alwaysExpanded, className, 
// Cast `x` to `externalX` to preserve name within the component logic
expanded: externalExpanded, items, trailing, onClick, leadingText, ...rest }) => {
    // Provide a fallback state for `expanded` if the parent doesn't pass anything
    const [expanded, setExpanded] = useState(false);
    const childItemsIndicator = items && !alwaysExpanded && React.createElement(Icon, { data: iconChevronSmall180 });
    const handleClick = (e) => {
        // In either of these cases we're ignoring `expanded` altogether
        if (externalExpanded === undefined && !alwaysExpanded && items) {
            setExpanded(!expanded);
        }
        if (onClick) {
            e.preventDefault();
            onClick(e);
        }
    };
    const trailingSlot = 
    // If both, pass a fragment so the NavItem will handle layout
    trailing && childItemsIndicator ? (React.createElement(React.Fragment, null,
        trailing,
        " ",
        childItemsIndicator)) : (
    // Otherwise, pass whichever one is true
    trailing || childItemsIndicator);
    return (React.createElement(React.Fragment, null,
        React.createElement(NavItem, { className: cx({
                // Prefer the parent's `expanded` to internal `expanded`
                'tds--expanded': externalExpanded !== null && externalExpanded !== void 0 ? externalExpanded : expanded,
            }, className), leadingText: leadingText, onClick: items || onClick ? handleClick : undefined, trailing: trailingSlot, ...rest }),
        React.createElement(SideNavItemGroup, { items: items, alwaysExpanded: alwaysExpanded })));
};
